import { SwitchInput } from '@calendly/ui/components/switch-input';
import BillingClickCapture from 'components/billing/click_capture';
import { getActivationFeatureKey, getActivationPaywallName } from '../../notifications/subsections/upgrade_enforcement';

// SwitchInput renders a visually-hidden input plus a decorative track, so the
// visible switch is only clickable when it is wrapped in a <label>. Without this
// the track has no associated control and toggling does nothing.
const switchLabelCss = "s1pl9669";

// Billing-gated activation switch for the CRUD notifications cards. Unlike the
// legacy switch, this is a controlled component driven by the shared root form
// state — toggling updates form values (persisted by the parent Save) rather than
// issuing an immediate PATCH. The billing gate still intercepts clicks so users
// without the entitlement see the paywall instead of enabling the notification.
export const CrudActivationSwitch = ({
  kind,
  checked,
  onToggle,
  disabled = false,
  'aria-label': ariaLabel
}) => <BillingClickCapture featureName={getActivationFeatureKey(kind)} paywallOverride={getActivationPaywallName(kind)} skipPreface noTracking>
    <label className={switchLabelCss}>
      <SwitchInput checked={checked} disabled={disabled} onChange={onToggle} aria-label={ariaLabel} />
    </label>
  </BillingClickCapture>;

require("./crud_activation_switch.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./crud_activation_switch.js");